module.exports = __webpack_public_path__ + "static/assets/872897b062d3e0c8baae8e5f0c8e651f.svg";